import Navigator from './components/Navigation';
import './style.css';
import './workDetailPage/style_works.css';
import './font.css';
import { Waiting } from './components/Waiting';
import {WorkTitle} from './workDetailPage/WorkTitle';
import work1image1 from './image/works/work4MainImage.webp';
import { WorkTextSection } from './workDetailPage/WorkTextSection';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import work1chart1 from './image/works/work1chart1.webp';
import { Dispatch, SetStateAction, useEffect } from 'react';
import wavedivider from './image/wavedivider.webp'
import {MainImage} from './workDetailPage/WorkMainImage';
import BackButton from './components/BackButton';
import thumbnail5 from './image/workThumbnails/thumbnail5.webp';
import NextItem from './components/NextItem';
import { useMetaTags } from './utils/useMetaTags';
import ProtectedPage from './components/ProtectedPage';
import { hashPasswordsFromEnv } from './utils/passwordUtils';

//LeadingMoreBusinessUserstoAdvertising

function Work2(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    useMetaTags({
      title: 'Leading More Business Users to Advertising - Lynkim',
      description: 'An experiment of UX to induce users to start advertising.',
      image: '/ogimage.png',
    });
    
    // 비밀번호는 .env.local의 REACT_APP_WORK_PASSWORD에 저장 (gitignored)
    const password = hashPasswordsFromEnv(process.env.REACT_APP_WORK_PASSWORD);
    
    return (
      // <ProtectedPage password={password} description="이 페이지는 비밀번호로 잠겨있어요">
      <>
      
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='fadeIn'>
        <WorkTitle 
          title={'Leading More Business Users to Advertising'} 
          description={'An experiment of UX to induce users to start advertising.'} 
          team={'Karrot(Daangn)'} 
          role={'User Research, Service Planning, UXUI Design'} 
          period={'2022.01. - 2022.08.'}
          titleKo={'광고 시작 전환을 높이기 위한 UX 실험'}
          descriptionKo={'광고를 시작하도록 유도하기 위한 UX 실험을 진행했습니다.'}
          teamKo={'당근마켓(Karrot)'}
          roleKo={'사용자 리서치, 서비스 기획, UXUI 디자인'}
          showButton={true}
            buttonLabel="View Project"
            buttonHref="https://www.figma.com/proto/iQ9Tgs7kQgjO6waM0oealt/Portfolio_lynkim?page-id=318%3A17734&node-id=318-20269&viewport=429%2C606%2C0.2&t=FH0n1cixdg4JTkII-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=318%3A20269"/>
      </div>
      <MainImage image={work1image1}/>
      {/* <Waiting/> */}
      <BackButton/>
      <NextItem to='/Work5' thumbnail={thumbnail5} nextProjectTitle='New Service Design'/>
      <div style={{ height: "400px" }} />
      </>
      // </ProtectedPage>
    )
}

export default Work2;
